import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../SalesRep/CreateInvoice/InvoiceStyle.css';
import EditIcon from '../../Images/ic_edit.svg';
import DeleteIcon from '../../Images/ic_delete.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faPlus, faSyncAlt, faMoneyBill, faReceipt } from '@fortawesome/free-solid-svg-icons';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import Regions from '../Common/Region';

const ProductDetails = {
    ID: 0,
    Quantity: 0,
    Gst: 0,
    Price: 0
};

const AdditionalPOInfo = {
    InvoiceNumber: "",
    TermsAndConditions: "",
};

const ProductTableValues = [];

const PurchaseOrder = () => {

    const { CurrentTheme } = useContext(ThemeContext);
    // eslint-disable-next-line
    const [companyInfo, setCompanyInfo] = useState([]);
    const [displayValue, setDisplayValue] = useState("none");
    const [displayValueAddress, setDisplayAddressValue] = useState("none");
    const [displayValueAdditionalDetails, setdisplayValueAdditionalDetails] = useState("none");
    const [Customers, setCustomers] = useState([]);
    const [Products, setProduct] = useState([]);
    const [CustomerAddress, setCustomersAddress] = useState({});
    const [selectedCustomer, setSelectedCustomer] = useState(0);
    const [SelectedPO, setSelectedPO] = useState(0);
    const [totalAmount, settotalAmount] = useState(0);
    const [ProductDetailsValue, setProductDetails] = useState(ProductDetails);
    const [ProductDetailsInitialValue, setProductInitialDetails] = useState(ProductDetails);
    const [ProductTable, setProductTable] = useState(ProductTableValues);
    const [PODetails, setPODetails] = useState(AdditionalPOInfo);
    const [selectedProduct, setselectedProduct] = useState(0);
    const [isEditProduct, setIsEditProduct] = useState(false);
    const [ImagePreview, setImagePreview] = useState(null);
    const [RegionSymbol, setRegionSymbol] = useState({});

    const [hidePO, sethidePO] = useState("none");
    const [POData, setPOData] = useState([]);


    useEffect(() => {
        FetchActiveCustomer();

        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const addProduct = () => {
        setIsEditProduct(false);
        setDisplayValue("block");
    };

    const customerAddressSuccess = (data) => {
        if (data.length > 0) {
            setCustomersAddress(data[0]);
        }
    };

    const showAddress = () => {
        if (selectedCustomer > 0) {
            Axiosfetch(baseURL + "GetCustomerDetailsByID", "POST", { ID: selectedCustomer }, customerAddressSuccess, Failure);
            setDisplayAddressValue("block");
        }
        else {
            //TODO
        }
    };

    const onNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
        setProductDetails({ ...ProductDetailsValue, [e.target.name]: value });
    };

    const onAdditionalPODetailsChange = (e) => {
        setPODetails({ ...PODetails, [e.target.name]: e.target.value });
    };

    const hideAddress = () => {
        setDisplayAddressValue("none");
    };

    const hideProduct = () => {
        setDisplayValue("none");
    };

    const hidePOModal = () => {
        sethidePO(hidePO === "none" ? "block" : "none");
    };

    const ImportPODetails = () => {
        let PO = parseInt(SelectedPO);
        setImagePreview(null);
        let SelectedPODetails = POData.filter(q => { return q.ID === PO });
        if (SelectedPODetails.length > 0) {
            setSelectedCustomer(SelectedPODetails[0].Customer.ID);
            setPODetails({ ...PODetails, InvoiceNumber: SelectedPODetails[0].InvoiceNumber ? SelectedPODetails[0].InvoiceNumber : "" });
        }

        if (PO > 0) {
            Axiosfetch(baseURL + "getPurchaseOrderInfo", "POST", { ID: PO }, ImportPOSuccess, Failure);
            sethidePO(hidePO === "none" ? "block" : "none");
        }
        else {
            Alert.error("Please Select PO", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const ImportPOSuccess = (data) => {
        let productData = [];
        for (var i = 0; i < data.length; i++) {
            let ProductDetail = {
                ID: data[i].Product.ID,
                Name: data[i].Product.Name,
                Quantity: data[i].ProductQuantity,
                Gst: data[i].Product.Gst,
                Price: data[i].Product.Price
            }

            productData.push(ProductDetail);
        }

        setProductTable(productData);
        UpDateTotalAmount(productData);
    };

    const hideAdditionalDetails = () => {
        setdisplayValueAdditionalDetails(displayValueAdditionalDetails === "none" ? "block" : "none");

    };

    const GetProductDetatails = (ID) => {
        setselectedProduct(ID);
        Axiosfetch(baseURL + "GetProductDetailsByID", "POST", { ProductID: ID }, ProductDetailsSuccess, Failure);
    }

    const ProductDetailsSuccess = (data) => {
        if (data.length > 0) {
            setProductDetails(data[0]);
            setProductInitialDetails(data[0]);
        }
        else {
            setProductDetails(ProductDetails);
        }
    };

    const customerDataSuccess = (data) => {
        if (data.length > 0) {
            setCustomers(data);
            Axiosfetch(baseURL + "GetActiveProducts", "GET", null, productDataSuccess, Failure);
        }
        else {
            setCustomers([]);
        }
    };

    const GetPOs = () => {
        Axiosfetch(baseURL + "GetAllPurchaseOrder", "GET", null, PODataSuccess, Failure);
    };

    const productDataSuccess = (data) => {
        if (data.length > 0) {
            setProduct(data);
            GetPOs();
        }
        else {
            setProduct([]);
        }
    };

    const PODataSuccess = (data) => {
        setPOData(data);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const SaveProductDetails = (products) => {
        let productExist = false;
        if (!isEditProduct) {
            ProductTable.forEach(product => {
                if (product.ID === products.ID) {
                    productExist = true;
                    return;
                }
            }
            );
        }

        if (!productExist && ValidateProduct(products)) {
            let productEditItemIndex = -1;
            if (isEditProduct) {
                ProductTable.forEach((product, index) => {
                    if (product.ID === products.ID) {
                        productEditItemIndex = index;
                        return;
                    }
                }
                );
            }

            if (productEditItemIndex > -1) {
                let arrayItem = [...ProductTable];
                arrayItem[productEditItemIndex].Quantity = products.Quantity;
                arrayItem[productEditItemIndex].Gst = products.Gst;
                arrayItem[productEditItemIndex].Price = products.Price;

                setProductTable(arrayItem);
            }
            else {
                ProductTable.push(products);
                setProductTable(ProductTable);
            }

            setDisplayValue("none");
            UpDateTotalAmount(ProductTable);
            setProductDetails([]);
            setselectedProduct(0);
        }
        else {
            if (productExist) {
                Alert.error("Product Already Added !!", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
    };

    const ValidateProduct = (products) => {
        let productErr = "";
        if (selectedProduct === 0) {
            productErr = "Please select valid Product.";
        }
        else if (!products.Quantity || products.Quantity <= 0) {
            productErr = "Please enter valid Quantity.";
        }
        else if (products.Gst <= 0) {
            productErr = "Please enter valid" + (RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST") + ".";
        }
        else if (products.Gst < ProductDetailsInitialValue.Gst) {
            productErr = `${RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST"} Cannot be less than ${ProductDetailsInitialValue.Gst} !!`;
        }
        else if (products.Price <= 0) {
            productErr = "Please enter valid Price.";
        }
        else if (products.Price < ProductDetailsInitialValue.Price) {
            productErr = `Price Cannot be less than ${ProductDetailsInitialValue.Price} !!`;
        }

        if (productErr !== "") {
            Alert.error(productErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const GeneratePO = () => {
        if (IsPODetailsValid()) {
            if (SelectedPO !== 0) {
                let podetails = POData.filter(p => p.ID === parseInt(SelectedPO));
                confirmAlert({
                    customUI: ({ onClose }) => {
                        return (
                            <div className={`custom-ui${CurrentTheme}`}>
                                {podetails.length > 0 && <p><b>Selected PO : </b>{"PO/" + (podetails[0].Customer ? podetails[0].Customer.Name.split(' ')[0].trim() : "") + "/#" + podetails[0].ID}/{moment(podetails[0].CreatedDate).local().format("DDMMYYYY")}</p>}
                                <h3>Generate PO Confirmation</h3>
                                <p>Choose the Valid option...</p>
                                <button type="button" style={{ fontSize: "1.4rem", marginRight: "10px" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={() => { GeneratePONext("Add"); GetPOs(); onClose(); }}>New</button>
                                <button type="button" style={{ fontSize: "1.4rem", marginRight: "10px" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={() => { UpdatePOItems(); onClose(); }}>Update</button>
                                <button type="button" className="btn btn-default" onClick={onClose}>Close</button>
                            </div>
                        );
                    }
                });
            }
            else {
                GeneratePONext("Add");
            }
        }
    };

    const GeneratePONext = (type) => {
        let TotalQuantityValue = 0;
        ProductTable.forEach(product => {
            TotalQuantityValue += product.Quantity;
        });

        var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
        if (userData) {
            const userID = parseInt(JSON.parse(userData).ID);
            //const RoleID = parseInt(JSON.parse(userData).Role.ID);

            let POCreationDetails = {
                ID: parseInt(SelectedPO),
                SupplierID: parseInt(selectedCustomer),
                PODetails: null,
                TotalQuantity: TotalQuantityValue,
                TotalAmount: totalAmount,
                CreatedDate: moment(new Date()).format('MM/DD/YYYY, HH:mm:ss'),
                InvoiceNumber: PODetails.InvoiceNumber.trim() === "" ? null : PODetails.InvoiceNumber,
                TermsAndConditions: PODetails.TermsAndConditions.trim() === "" ? null : PODetails.TermsAndConditions,
                UserID: userID,
                InvoiceImage: ImagePreview
            };

            if (type === "Edit") {
                Axiosfetch(baseURL + "EditPurchaseOrder", "POST", POCreationDetails, POItemsCreationSuccess, Failure);
            }
            else {
                Axiosfetch(baseURL + "CreatePurchaseOrder", "POST", POCreationDetails, POCreationSuccess, Failure);
            }
        }
        else {
            Alert.error("Error occured While Generating PO. Please login to the application again before attempting the steps.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    }

    const UpDateTotalAmount = (ProductInfo) => {
        let value = 0;
        ProductInfo.forEach(data => {
            value = value + ((parseFloat(data.Quantity) * parseFloat(data.Price)) * (parseFloat(data.Gst) / 100)) +
                (parseFloat(data.Quantity) * parseFloat(data.Price));
        });
        settotalAmount(value.toFixed(2));
    };

    const IsPODetailsValid = () => {
        let ErrorMsg = "";
        if (parseInt(selectedCustomer) === 0) {
            ErrorMsg = "Please Select a Customer.";
        }
        else if (ProductTable.length === 0) {
            ErrorMsg = "Please add the Products."
        }

        if (ErrorMsg !== "") {
            Alert.error(ErrorMsg, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const POCreationSuccess = (data) => {
        let POitems = [];
        if (data.ID && data.ID > 0) {
            ProductTable.forEach(product => {
                POitems.push({
                    POID: parseInt(data.ID),
                    ProductID: parseInt(product.ID),
                    ProductQuantity: parseInt(product.Quantity),
                    ProductPrice: parseFloat(product.Price),
                    ProductGST: parseFloat(product.Gst),
                    IsDeleted: 0
                });
            });
        }

        Axiosfetch(baseURL + "CreatePOItems", "POST", POitems, POItemsCreationSuccess, Failure);
    }

    const POItemsCreationSuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        settotalAmount(0);
        setProductTable([]);
        setPODetails(AdditionalPOInfo);
        setImagePreview(null);
        setSelectedCustomer(0);

        let poID = parseInt(SelectedPO);
        Axiosfetch(baseURL + "DeletePOSnapShotByID", "POST", { POID: poID }, DeleteSnapShotSuccess, Failure);
    };

    const DeleteSnapShotSuccess = (data) => {

    };

    const UpdatePOItems = () => {
        let POID = parseInt(SelectedPO);
        Axiosfetch(baseURL + "DeletePOItems", "POST", { POID: POID }, POItemsDeleteSuccess, Failure);
    }

    const POItemsDeleteSuccess = (result) => {
        if (result === "POItems Deleted Successfully") {
            let POitems = [];

            ProductTable.forEach(product => {
                POitems.push({
                    POID: parseInt(SelectedPO),
                    ProductID: parseInt(product.ID),
                    ProductQuantity: parseInt(product.Quantity),
                    ProductPrice: parseFloat(product.Price),
                    ProductGST: parseFloat(product.Gst),
                    IsDeleted: 0
                });
            });

            Axiosfetch(baseURL + "CreatePOItemsForUpdate", "POST", POitems, POItemsUpdateSuccess, Failure);
        }
        else {
            Alert.error("Something went Wrong. Please try again.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    }

    const POItemsUpdateSuccess = (data) => {
        if (data === "POItems Added Successfully") {
            GeneratePONext("Edit");
        }
    };

    const onInvoiceAttach = (e) => {
        var selectedFile = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = function () {
            getfileData(reader.result);
        };
    };

    const getfileData = (data) => {
        setImagePreview(data);
    };

    const DeleteSelectedProduct = (productID) => {
        let ProductValue = ProductTable.filter(p => { return p.ID !== productID });
        setProductTable(ProductValue);
        UpDateTotalAmount(ProductValue);
        setProductDetails([]);
        setselectedProduct(0);
    };

    const EditSelectedProduct = (productID) => {
        setIsEditProduct(true);
        let ProductValue = ProductTable.filter(p => { return p.ID === productID });
        if (ProductValue.length > 0) {
            let ProductDetailsEdit = {
                ID: ProductValue[0].ID,
                Quantity: ProductValue[0].Quantity,
                Gst: ProductValue[0].Gst,
                Price: ProductValue[0].Price,
            };

            setProductDetails(ProductDetailsEdit);
            setProductInitialDetails(ProductDetailsEdit);
            setselectedProduct(ProductValue[0].ID);
            setDisplayValue("block");
        }
        else {
            Alert.error("Something went Wrong. Please try again.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const SaveAdditionalPODetails = () => {
        UpDateTotalAmount(ProductTable);
        hideAdditionalDetails();
    };

    const FetchActiveCustomer = () => {
        setProductTable([]);
        setPODetails(AdditionalPOInfo);
        GetCompanyInfo();
        Axiosfetch(baseURL + "GetActiveCustomers", "GET", null, customerDataSuccess, Failure);
    };

    const GetCompanyInfo = () => {
        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setPODetails({ ...PODetails, "TermsAndConditions": companyDetails.POTermsAndCondition });
        }
    }



    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div id="page">
                    <div className="row">
                        <div className="col-md-11 col-sm-11">
                            <h5 className="align-center" style={{ fontWeight: "500" }}>Purchase Order System</h5>
                        </div>

                    </div>
                    <div className="row title customerStyle">
                        <div className="col-md-3 col-sm-5">
                            <h5 style={{ fontWeight: "600" }}>Supplier Name<span className="mandatoryStar">*</span></h5>
                        </div>
                        <div className="col-md-7 col-sm-6">
                            <div className="basic-select">
                                <select className="DropdownStyle" value={selectedCustomer} style={{ width: "90%" }} onChange={(e) => setSelectedCustomer(e.target.value)}>
                                    <option value="0">Select Customer</option>
                                    {
                                        Customers.length && Customers.map(customer => (
                                            <option key={customer.ID} value={customer.ID}>{customer.Name}</option>
                                        )
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        {selectedCustomer > 0 && (<div className={`col-md-2 col-sm-1 align-right font-size-15rem cursor ${CurrentTheme === "default" ? "addressCardStyle" : "addressCardStyleDark"}`}>
                            <div onClick={showAddress}>
                                <FontAwesomeIcon icon={faAddressCard} />
                            </div>
                        </div>)}
                    </div>

                    <div className="row title">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-9 col-sm-8">
                                    <h5 style={{ fontWeight: "600" }}>Product Details</h5>
                                </div>
                                <div className="col-md-2 col-sm-2 align-right cursor font-size15rem">
                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <span style={{ paddingRight: "20px" }} className={`addressCardStyle ${CurrentTheme}Color`} data-tip="Add Products" onClick={addProduct}><FontAwesomeIcon icon={faPlus} style={{ marginRight: "5px" }} /></span>
                                        <span className={`addressCardStyle ${CurrentTheme}Color`} data-tip="Add Additional Details" onClick={hideAdditionalDetails}><FontAwesomeIcon icon={faMoneyBill} style={{ marginRight: "5px" }} /></span>
                                    </div>
                                </div>
                                <div data-tip="Import Purchase Order" onClick={hidePOModal} className={`col-md-1 col-sm-1 align-right cursor ${CurrentTheme === "default" ? "addressCardStyle" : "addressCardStyleDark"}`} style={{ fontSize: "1.4rem" }}>
                                    <FontAwesomeIcon icon={faReceipt} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 tableStyle">
                            <table className="table table-striped">
                                <thead className="StickyHeader">
                                    <tr>
                                        <th style={{ display: "none" }}>ProductID</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Product</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>{RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST"} (%)</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Quantity</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Unit Price</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Amount</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        ProductTable.length > 0 && ProductTable.map(product => (
                                            <tr key={product.ID} className="textCenter">
                                                <td style={{ display: "none" }}>{product.ID}</td>
                                                <td className="tdtableProductStyle">{product.Name}</td>
                                                <td>{product.Gst} %</td>
                                                <td>{product.Quantity}</td>
                                                <td>{product.Price}</td>
                                                <td>{((parseFloat(product.Quantity) * parseFloat(product.Price)) * (parseFloat(product.Gst) / 100)) + parseFloat(product.Quantity) * parseFloat(product.Price)}</td>
                                                <td><img className="cursorpointer" src={EditIcon} alt="Edit" onClick={(productID) => EditSelectedProduct(product.ID)}></img>
                                                    <img className="cursorpointer" onClick={(productID) => DeleteSelectedProduct(product.ID)} style={{ marginLeft: 15 }} src={DeleteIcon} alt="Delete"></img>
                                                </td>
                                            </tr>
                                        )
                                        )
                                    }

                                    {
                                        ProductTable.length === 0 && (<tr><td colSpan="6" style={{ textAlign: "center" }}>No products added to Purchase Order.</td></tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-md-8 col-sm-8 align-right">

                            <button className={`btn btn-General ${CurrentTheme}Focus`} style={{ width: "150px" }} onClick={GeneratePO}> <FontAwesomeIcon icon={faSyncAlt} style={{ marginRight: "5px" }} /> Generate</button>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" style={{ fontWeight: "600", minWidth: "150px" }}>Total</span>
                                </div>
                                <input type="text" readOnly={true} className="form-control align-center" style={{ minWidth: "60px" }}
                                    value={totalAmount}></input><div>
                                    {RegionSymbol.Symbol && (<FontAwesomeIcon className="font-size2rem padding-topLeft" icon={RegionSymbol.Symbol}></FontAwesomeIcon>)}
                                    {RegionSymbol.Symbol === null && (<div style={{ padding: "5px 0 0 10px" }}>{RegionSymbol.Currency}</div>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="myModal" className="modal" style={{ display: displayValue }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>Add Product</span>
                            <span className="close" onClick={hideProduct}>&times;</span>
                        </div>
                        <div>
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <h5>Product Name<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <div className="basic-select">
                                                <select className="DropdownStyle" value={selectedProduct} onChange={(e) => GetProductDetatails(e.target.value)} style={{ width: "95%" }}>
                                                    <option value="0" defaultValue="0">Select Product</option>
                                                    {
                                                        Products.length > 0 && Products.map(Product => (
                                                            <option key={Product.ID} value={Product.ID}>{Product.Name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Quantity<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <input type="number" name="Quantity" min="0" pattern="[0-9]*" className="form-control"
                                                onChange={e => onNumberChange(e)} value={ProductDetailsValue.Quantity ? ProductDetailsValue.Quantity : 0}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>{RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST"}<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <input type="number" name="Gst" min="0.00" step="any" className="form-control"
                                                onChange={e => onNumberChange(e)} value={ProductDetailsValue.Gst ? ProductDetailsValue.Gst : 0}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Price<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <input type="number" name="Price" min="0" step="any" className="form-control"
                                                onChange={e => onNumberChange(e)} value={ProductDetailsValue.Price ? ProductDetailsValue.Price : 0}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "right" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={() => SaveProductDetails(ProductDetailsValue)}>Save</button>
                                                    <button type="button" className="btn btn-default" onClick={hideProduct}>Close</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div id="myModal2" className="modal" style={{ display: displayValueAddress }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>Customer Information</span>
                            <span className="close" onClick={hideAddress}>&times;</span>
                        </div>

                        <div className="row">
                            <table className="table tableTDWidthStyle">
                                <tbody>
                                    <tr>
                                        <td>
                                            <h4>Address</h4>
                                        </td>
                                        <td>
                                            <label>{CustomerAddress && CustomerAddress.Address}</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h4>Phone Number</h4>
                                        </td>
                                        <td>
                                            <label>{CustomerAddress && CustomerAddress.PhoneNumber}</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h4>Email</h4>
                                        </td>
                                        <td>
                                            <label>{CustomerAddress && CustomerAddress.EmailID}</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h4>{RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST"}</h4>
                                        </td>
                                        <td>
                                            <label>{CustomerAddress && CustomerAddress.CustomerGST}</label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div id="SelectPrevPO" className="modal" style={{ display: hidePO }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>Select PO</span>
                            <span className="close" onClick={hidePOModal}>&times;</span>
                        </div>

                        <table className="table tableTDWidthStyle">
                            <tbody>
                                <tr className="align-center">
                                    <td style={{ width: "30%" }}>
                                        <h4>Purchase Order<span className="mandatoryStar">*</span></h4>
                                    </td>
                                    <td style={{ width: "70%" }}>
                                        <div className="basic-select">
                                            <select className="DropdownStyle" style={{ width: "90%" }} onChange={(e) => setSelectedPO(e.target.value)}>
                                                <option value="0">Select PO</option>
                                                {
                                                    POData.length && POData.map(PO => (
                                                        <option key={PO.ID} value={PO.ID}>{"PO/" + (PO.Customer ? PO.Customer.Name.split(' ')[0].trim() : "") + "/#" + PO.ID}/{moment(PO.CreatedDate).local().format("DDMMYYYY")}</option>
                                                    )
                                                    )
                                                }
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="2">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={ImportPODetails}>Select</button>
                                                <button type="button" className="btn btn-default" onClick={hidePOModal}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div id="myModal3" className="modal" style={{ display: displayValueAdditionalDetails }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>Additional Details</span>
                            <span className="close" onClick={hideAdditionalDetails}>&times;</span>
                        </div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h5>Invoice Number</h5>
                                    </td>
                                    <td>
                                        <input onChange={(e) => onAdditionalPODetailsChange(e)}
                                            className="form-control" name="InvoiceNumber"
                                            value={PODetails.InvoiceNumber}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Invoice Attachment</h5>
                                    </td>
                                    <td>
                                        <input type="file" className="form-control" name="InvoiceAttachent"
                                            onChange={onInvoiceAttach} ></input>
                                    </td>
                                </tr>
                                {ImagePreview && (<tr>
                                    <td colSpan="2">
                                        <embed src={ImagePreview} type="application/pdf"
                                            width="100%" height="600px" />
                                    </td>
                                </tr>)}

                                <tr>
                                    <td>
                                        <h5>Terms and Conditions</h5>
                                    </td>
                                    <td>
                                        <textarea onChange={(e) => onAdditionalPODetailsChange(e)}
                                            rows="3" className="form-control" name="TermsAndConditions"
                                            value={PODetails.TermsAndConditions}></textarea>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="2">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SaveAdditionalPODetails}>Save</button>
                                                <button type="button" className="btn btn-default" onClick={hideAdditionalDetails}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseOrder;